<template>
  <div class="card mt-3">
    <div class="card-header border-0">
      <h5 class="card-title">تنظیمات ارسال</h5>
    </div>
    <div class="card-body">

    </div>
  </div>
</template>

<script>
export default {
  name: "ProductShippingConfig"
}
</script>

<style scoped>

</style>